import type { FaireProductEntity } from "../../entity_types/product";

export const p_b7tqfj6z9q: FaireProductEntity = {
  token: "p_b7tqfj6z9q",
  type: "product",
  name: "Beef Tallow Potato Chips - Sour Cream N' Onion",
  brandToken: "b_d6aqh4qdhb",
  brandName: "Beefy's Own",
  imageUrl:
    "https://cdn.faire.com/fastly/f78a2599c0a0e9dce7779e5c52b5a02429b6e9b43cdcd4664814acf539f6d837.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0fb515e1a14af2337dead46631f56ad246305900e92d70dc6b4ca51f954992e8.png",
    "https://cdn.faire.com/fastly/b8dc79cf8f37468aab4abd4f84e9ba4fca23a616f294cadbcd3b47c5b73c4aa0.png",
    "https://cdn.faire.com/fastly/8c6628b95d054d306297e23d9893c2deea49a40aa0668c39242df7d4fbfe978d.png",
    "https://cdn.faire.com/fastly/58c1500ddf9243d85ff1a9b587b6467fd1357b8840e961cdf66a197f30cb7f1e.png",
    "https://cdn.faire.com/fastly/034381041e9b3c3880b796ee776204a09cb9101388ea596d0f69a79161d3c799.png",
    "https://cdn.faire.com/fastly/a6549e9431b3ac000869fead1199605d2b735b97d78d0ff780f9faf87e0b87e4.png",
    "https://cdn.faire.com/fastly/55ef0bfb195c89b3420c389eaa3fbf62cf075f758c6f4cf173aadd9712a66dce.png",
  ],
  priceDollars: 6.5,
  description:
    "Perfect, crispy, golden potato chips fried the old-fashioned way in pure beef tallow - bringing back old-school flavor you forgot existed. Our Sour Cream N' Onion chips hit just right - tangy, creamy, and savory in every bite. With the smooth richness of sour cream, a gentle touch of onion and garlic, and a balanced finish, the flavor is bold but never overpowering - always just right. Our dedicated team of chip artisans takes pride in ensuring every chip meets the highest standards of taste and texture. From the satisfying crunch to the perfectly seasoned finish, these small-batch chips deliver a snack experience like no other.\n\n-5oz bags-\nNon-GMO Potatoes, Beef Tallow, Onion Powder, Sour Cream Powder, Buttermilk Powder, Sea Salt, Dehydrated Dill, Dehydrated Chive, Dehydrated Parsley.",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T21:11:38.761Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
